import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import PaymentListMain from "Components/Common/PaymentMain/PaymentListMain";
import ImportDuplicateMain from "Components/ImportDuplicate/ImportDuplicateMain";

const ImportDuplicate = () => {
  return (
    // <ContainerWrapper>
    <ImportDuplicateMain />
    // </ContainerWrapper>
  );
};

export default ImportDuplicate;
